<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1 style="font-family:Times New Roman;">Acknowledgments</h1>
<p style="text-indent:0px;">I want to acknowledge the continued support and encouragement of my wife, Lisa, for my paddling and writing endeavors. Without her, these adventures and books would not have happened.</p><br/>
<p style="text-indent:0px;">I’d also like to acknowledge the work of my editor, Rowena Cernan, of the Book Concierge for her invaluable help in cleaning up the writing of a punctuationally challenged author.</p><br/>
<p style="text-indent:0px;">Finally, thank you to all the wonderful folks who people the tales presented here. You have enriched my life more than you will ever know.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?60b237e0